// extracted by mini-css-extract-plugin
export default {"icon":"onboarding_icon__Qbkpu","text":"onboarding_text__SQFyC","title":"onboarding_title__CYBmF","container":"onboarding_container__Xyrbi"};